import { Component, inject, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { GlobalState } from '../../store';
import { pullLocker, pullLockerNextPage } from '../../store/locker/locker.actions';
import {
  selectLockerProcessing,
  selectLockerProcessingNextPage,
  selectMyLocker,
  selectMyLockerNextPage,
} from '../../store/locker/locker.selectors';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MyLockerItem } from '@fan-types/bid';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'locker',
  templateUrl: './locker.component.html',
  styleUrls: ['./locker.component.scss'],
  standalone: false,
})
export class LockerComponent implements OnDestroy {
  // myBids$ = this.store.select(selectMyLocker);
  processing$ = this.store.select(selectLockerProcessing);
  section: 'live' | 'won' | 'lost' = 'live';
  page = 0;
  bids: MyLockerItem[] = [];
  isNextPage = true;
  subscriptions: Subscription[] = [];
  loadingInitialContent = true;
  loadingNextContent = true;
  gettingInitialPage = true;
  selectedTabIndex = 0;

  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);

  constructor(private store: Store<GlobalState>) {
    // Set initial section from params
    const initialSection = this.activatedRoute.snapshot.queryParams.section;
    if (initialSection) {
      this.section = initialSection as 'live' | 'won' | 'lost';
      this.selectedTabIndex = this.section === 'live' ? 0 : this.section === 'won' ? 1 : 2;
    }
    this.store.dispatch(pullLocker({ section: this.section }));
    this.subscriptions.push(
      this.store.select(selectMyLocker).subscribe((state) => {
        if (state.firstPage) {
          this.gettingInitialPage = false;
          this.bids = state.bids;
          this.isNextPage = state.nextPage;
        }
      })
    );
    this.subscriptions.push(
      this.processing$.subscribe((value) => {
        this.loadingInitialContent = value ?? false;
      })
    );
    this.subscriptions.push(
      this.store.select(selectLockerProcessingNextPage).subscribe((value) => {
        this.loadingNextContent = value ?? false;
      })
    );
    this.subscriptions.push(
      this.store.select(selectMyLockerNextPage).subscribe((state) => {
        if (state.nextBids?.length) {
          this.bids = [...this.bids, ...state.nextBids];
        }
        this.isNextPage = state.nextPage;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub?.unsubscribe());
  }

  tabChanged(event: MatTabChangeEvent) {
    this.bids = [];
    this.loadingInitialContent = true;
    this.isNextPage = true;
    this.gettingInitialPage = true;
    const selectedIndex = event.index;
    switch (selectedIndex) {
      case 0:
        this.section = 'live';
        break;
      case 1:
        this.section = 'won';
        break;
      case 2:
        this.section = 'lost';
        break;
      default:
        this.section = 'live';
        break;
    }
    this.page = 0;
    this.router.navigate([], { queryParams: { section: this.section } });
    this.store.dispatch(pullLocker({ section: this.section }));
  }

  loadMore() {
    if (!this.isNextPage || this.loadingNextContent) return;

    this.loadingNextContent = true;
    this.page++;
    this.store.dispatch(
      pullLockerNextPage({ section: this.section, skip: this.page * 20, limit: 20 })
    );
  }
}
